import { ReactNode, useEffect } from "react";
import { AuthContext } from "./AuthContext";
import { authClient } from "../../auth/client";
import { useMutation } from "@tanstack/react-query";

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const { mutate: signOut } = useMutation({
    mutationFn: async () => {
      return authClient.signOut();
    },
    retry: false,
  });

  useEffect(() => {
    const handler = () => signOut();
    window.addEventListener("ow:api-unauthenticated-response", handler);
    return () =>
      window.removeEventListener("ow:api-unauthenticated-response", handler);
  }, [signOut]);

  return (
    <AuthContext.Provider
      value={{
        logout: signOut,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
